export const PrivacyPolicy = () => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://classlegal.com/pages/privacy-policy"
    >
      Privacy Policy
    </a>
  );
};
